export const UMAMI_ANALYITCS_TRACKING_ID = 'backstage.io/tracking-id';
